module.exports = "/images/home-sell.png?dbc298cf916383a5e4078a64d4106bcb";